import { render } from "./SidebarCategory.vue?vue&type=template&id=09a934e7&ts=true"
import script from "./SidebarCategory.vue?vue&type=script&lang=ts"
export * from "./SidebarCategory.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__